/* eslint-disable no-underscore-dangle */
/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

import Card from "@mui/material/Card";
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import CardTitle from "components/CardTitle";
import { useTranslation } from "react-i18next";
import Calendar from "components/Calendar";
import enLocale from "@fullcalendar/core/locales/en-gb";
import esLocale from "@fullcalendar/core/locales/es";
import serviceUtils from "../project/components/servicesConfig/serviceUtils";

function ServiceEventsCalendar({
  events,
  handleDateSelect,
  handleEventClick,
  service,
  initialDate,
}) {
  const { t, i18n } = useTranslation();

  const { addColorByStatusToEvents, renderEventContent, getAllowedMaxHourInCalendarView } =
    serviceUtils;

  const serviceName = service?.name;

  const allowedStart = service?.startTime;
  const serviceEndTime = service?.endTime;

  const durationTime = service?.serviceDuration;

  const allowedEnd = getAllowedMaxHourInCalendarView(durationTime);

  const daysOfWeekAllowed = service?.availableDays;

  const coloredEvents = addColorByStatusToEvents(events);

  return (
    <Card
      sx={{
        "& .fc .fc-timegrid-slot": {
          height: "5rem",
        },
      }}
    >
      <CardTitle title={`${t("service")} ${serviceName}`} icon="access_time" bgColor="warning" />
      <Calendar
        headerToolbar={{
          start: "today prev,next",
          center: "title",
          end: "dayGridMonth,timeGridWeek,timeGridDay",
        }}
        allDaySlot={false} // Elimina la fila "todo el dia"
        expandRows={false} // La altura del calendario se ajuste a las horas trabajadas
        slotMinTime={`${allowedStart}:00`} // Limita el rango horario visible en vistas timeGridWeek / timeGridDay.
        // slotMaxTime={`${allowedEnd}:00`}
        // slotMaxTime="30:00"
        slotMaxTime={`${allowedEnd}:00`}
        dayMaxEventRows={4} // Máximo número de eventos visibles por día antes de mostrar “… más”.
        initialView="timeGridWeek" // Vista inicial del calendario.Opciones comunes: dayGridMonth, timeGridWeek, timeGridDay
        initialDate={initialDate} // Fecha por defecto donde se sitúa el calendario al cargar.
        events={coloredEvents}
        eventContent={renderEventContent} // Permite personalizar cómo se renderiza cada evento.
        locale={i18n.language === "es" ? esLocale : enLocale}
        contentHeight={750} // altura del área donde se pintan los eventos
        height={750} // altura general del componente
        selectable // Activa la selección con el ratón:
        select={handleDateSelect} // Callback cuando el usuario selecciona un intervalo de tiempo.
        eventClick={handleEventClick} // Se ejecuta al hacer clic sobre un evento.
        eventOverlap // Permite que los eventos se superpongan visualmente en vistas timeGrid.
        slotEventOverlap // eventOverlap, pero aplicado específicamente a eventos en la misma franja horaria.
        businessHours={{
          daysOfWeek: daysOfWeekAllowed,
          startTime: allowedStart,
          endTime: serviceEndTime,
        }} // Marca visualmente el horario permitido de reserva.
        selectConstraint={{
          startTime: allowedStart,
          endTime: serviceEndTime,
        }} // Limita la selección SOLO dentro de un rango horario.
      />
    </Card>
  );
}

ServiceEventsCalendar.defaultProps = {
  events: [],
  handleDateSelect: () => {},
  handleEventClick: () => {},
  service: {},
  initialDate: Date.now(),
};

ServiceEventsCalendar.propTypes = {
  events: PropTypes.array,
  handleDateSelect: PropTypes.func,
  handleEventClick: PropTypes.func,
  service: PropTypes.object,
  initialDate: PropTypes.any,
};

export default ServiceEventsCalendar;
